export enum SystemStatusEnum {
    // Tier 1
    POWER = 'power',
    IMPACT_ALERT_LEVEL_9 = 'impact_alert_level_9',
    IMPACT_ALERT_LEVEL_8 = 'impact_alert_level_8',
    IMPACT_ALERT_LEVEL_7 = 'impact_alert_level_7',
    METER_ISSUE = 'meter_issue',
    STORAGE_IDLE = 'storage_idle',
    GATEWAY_CRITICAL = 'gateway_critical',
    NEVER_CONNECTED = 'never_connected',
    COMPONENT_ERROR = 'component_error',
    BATTERY_COMMS = 'battery_comms',
    BATTERY_FAULT = 'battery_fault',
    BLACK_START_FAILURE = 'black_start_failure',
    CONTACTOR_UNRESPONSIVE_CLOSE = 'contactor_unresponsive_close',
    GENERATOR_FAULTED = 'generator_faulted',
    INVERTER_NOT_GOING_TO_VF = 'inverter_not_going_to_vf',
    ISLANDING_CONTROLLER_MIA = 'islanding_controller_mia',
    OPTICASTER_EXE = 'opticaster_exe',

    // Tier 2
    IMPACT_ALERT_LEVEL_6 = 'impact_alert_level_6',
    IMPACT_ALERT_LEVEL_5 = 'impact_alert_level_5',
    IMPACT_ALERT_LEVEL_4 = 'impact_alert_level_4',
    MICRO = 'micro',
    ENCHARGE_ISSUE = 'encharge_issue',
    SYSTEM = 'system',
    ENPOWER_ISSUE = 'enpower_issue',
    GATEWAY = 'gateway',
    SYSTEM_DISCONNECTED = 'system_disconnected',
    BATTERY_BREAKER_OPEN = 'battery_breaker_open',
    BATTERY_METER_COMMS = 'battery_meter_comms',
    BUSWAY_METER_COMMS = 'busway_meter_comms',
    EXTERNAL_IO_COMMS = 'external_io_comms',
    FREQUENCY_METER_COMMS = 'frequency_meter_comms',
    GENERATOR_BREAKER_TIMEOUT = 'generator_breaker_timeout',
    GENERATOR_METER_COMMS = 'generator_meter_comms',
    GRID_RESYNCHRONIZATION_FAILED = 'grid_resynchronization_failed',
    LOST_CONNECTIVITY_TO_SITE_CONTROLLER = 'lost_connectivity_to_site_controller',
    LOAD_METER_COMMS = 'load_meter_comms',
    PV_INVERTER_COMMS = 'pv_inverter_comms',
    PYRANOMETER_COMMS = 'pyranometer_comms',
    SITE_METER_COMMS = 'site_meter_comms',
    SOLAR_METER_COMMS = 'solar_meter_comms',
    SYSTEM_SHUTDOWN = 'system_shutdown',
    WAIT_FOR_SOLAR = 'wait_for_solar',

    // Tier 3
    IMPACT_ALERT_LEVEL_3 = 'impact_alert_level_3',
    IMPACT_ALERT_LEVEL_2 = 'impact_alert_level_2',
    IMPACT_ALERT_LEVEL_1 = 'impact_alert_level_1',
    BATTERY = 'battery',
    ENCHARGE = 'encharge',
    METER = 'meter',
    ENPOWER = 'enpower',
    ACTIVATION = 'activation',
    UNKNOWN_STATUS = 'unknown_status',
    WAITING_FOR_JUMPSTART_LOW_SOE = 'waiting_for_jumpstart_low_soe',

    // Normal
    NORMAL = 'normal',

    // Unmonitored
    PENDING = 'pending',
    DELAYED = 'delayed',
    SYSTEM_NOT_FOUND = 'system_not_found',

    // Excluded
    AUTH_ERROR = 'auth_error',
    UNKNOWN_MANUFACTURER = 'unknown_manufacturer',
    INTEGRATION_UPDATE_REQUIRED = 'integration_update_required',
    MISSING_INTEGRATION = 'missing_integration',

    UNKNOWN = 'unknown'
}
